<template>
  <div id="editDeviceModal" class="col-12 justify-content-center pe-6"  style="padding: 5vh 15%">
  <!--<div id="editDeviceModal" :class="showConfiguration === 'false' ? 'modal-overlay' : 'row col-12 m-0 p-0'" style="padding: 15vh 2%">-->
    <div class="col-12 m-0 p-0 section-container rounded-5 shadow">

      <!-- HEAD New Device -->
      <div class="row overflow-hidden col-12 m-0 p-0 text-white rounded-top-5 pb-1 h-100 bg-lat1">
        <div class="col-6">
          <h6 class="lh-1 tx-left tx-white mb-2 ps-1 pt-2">
            <ion-icon name="hardware-chip" class="tx-18 me-2 align-bottom"></ion-icon>
            {{ dictionary['Editar dispositivo'][session.user.language] + ": " + editDeviceData.label }}
            </h6>
        </div>

        <button type="button" @click="saveDevice" id="btnSaveDevice"
          class="col-5 col-md-3 button-ok bg-primary border-white m-1 ms-auto pb-1 btn"
          style="max-height: 34px;">
          <span class="button-text text-white">
            <ion-icon name="create-outline"
              class="text-white p-0 m-auto tx-24 hydrated"></ion-icon>
            <span class="text-white m-auto">
              {{ dictionary['Guardar cambios'][session.user.language] }}
            </span>
          </span>
        </button>

        <div class="col-auto m-0 p-0 d-flex justify-content-end btn" @click="$emit('toggleEditDeviceModal')">	
          <ion-icon name="close" class="ms-auto tx-30 pt-1 pe-1 tx-white align-bottom"></ion-icon>
        </div>
      </div>

      <div class="col-12 m-0 overflow-hidden justify-content-center bg-lat1 p-0 rounded-bottom-5">
        <div class="row col-12 table-responsive m-0 p-0 pb-3" style="overflow: hidden;">

          <!-- CONTENT Edit Device -->
          <div class="m-0 p-0 w-100 pe-3 ps-3" style="background-color: #03103e;">
            <div id="editDeviceScroll" style="overflow: scroll; overflow-x: hidden; max-height: 85vh;">
              <div class="col-12 p-2 pe-0 pb-0">

                <!-- CONTENT Edit Device -->
                <form class="p-0 overflow-hidden d-flex flex-wrap pe-2">
                  <div class="col-12 m-0 p-2 rounded-5" style="background-color: #03103e;">
                    <form class="col-12 m-0 p-0 overflow-hidden">
                      <div class="row col-12 container-fluid p-0 pt-2 m-0">
                        <div class="border rounded-5 row bg-lat1 text-white p-0 m-0 mb-3">
                              <div class="col-12 row mb-2">
                                <div class="col-3 d-flex flex-column">
                                  {{ dictionary['Tipo'][session.user.language] + ": " }}
                                  <span class="tx-11 tx-start">{{ editDeviceData.type ? editDeviceData.type : '-'
                                  }}</span>
                                </div>
                                <div class="col-3 d-flex flex-column">
                                  {{ dictionary['Categoría'][session.user.language] + ": " }}
                                  <span class="tx-11 tx-start">{{ editDeviceData.category ? editDeviceData.category :
                                    '-' }}</span>
                                </div>

                                <div class="col-3 d-flex flex-column">
                                  <span class="tx-13 tx-bold mt-2">{{ dictionary['Versión'][session.user.language] + ":"
                                  }}</span>
                                  <span class="tx-11 tx-start">{{ editDeviceData.version ? editDeviceData.version :
                                    '-' }}</span>
                                </div>
                                <div class="col-3 d-flex flex-column">
                                  <span class="tx-13 tx-bold mt-2"> {{ dictionary['Comunicación'][session.user.language]
                                    +
                                    ": " }} </span>
                                  <span class="tx-11 tx-start">
                                    {{ editDeviceData.communicationDateTime !== undefined &&
                                      editDeviceData.communicationDateTime !== "" ?
                                      this.$dayjs(new Date(editDeviceData.communicationDateTime))
                                        .utc("z").local().tz(this.session.user.dateTimeZone)
                                        .format(this.session.user.dateTimeFormat + ' ' + 'HH:mm:ss') : "-" }}
                                  </span>
                                </div>
                              </div>
                            </div>

                        <div class="col-md-6 col-12 rounded-5 container-fluid p-0 pt-0 m-0 mb-4">
                          <div class="row col-12 p-2 pt-0 m-0 justify-content-around">
                            <div class="row bg-lat1 text-white m-0 p-0 rounded-5 border justify-content-between">
                              <!-- GENERALES -->
                              <label class="col-md-4 col-12 p-0 pb-2 pt-2 ps-3 mt-1 text-white tx-bold tx-16">
                                {{ dictionary['Generales'][session.user.language] }}
                              </label>
                            </div>
                            
                            <div class="rounded-5 row p-0 m-0 pt-2 justify-content-around">
                              <!-- NOMBRE -->
                              <div class="col-lg-5 col p-0 tx-left">
                                <label class="p-0 text-white tx-12">
                                  {{ dictionary['Nombre'][session.user.language] }}
                                </label>
                                <input v-model="editDeviceData.label" id="inputEditDeviceLabel" type="text"
                                  v-on:change="dataHasChanged=true"
                                  class="form-control form-control-line text-black bg-white">
                              </div>
                              <!-- TIPO -->
                              <div class="col-lg-5 col p-0 p-0 tx-left">
                                <label class="p-0 pt-1 text-white tx-12">
                                  {{ dictionary['Orden'][session.user.language] }}
                                </label>
                                <input v-model="editDeviceData.distributionGroup" id="inputEditDeviceDistributionGroup" type="text"
                                  v-on:change="dataHasChanged=true"
                                  class="form-control form-control-line text-black bg-white">
                              </div>
                              <div class="col-lg-5 col p-0 p-0 tx-left">
                                <label class="p-0 pt-1 text-white tx-12">
                                  {{ dictionary['Identificador'][session.user.language] }}
                                </label>
                                <input v-model="editDeviceData.id" disabled id="inputEditDeviceId" type="text"
                                  v-on:change="dataHasChanged=true"
                                  class="form-control form-control-line text-dark">
                              </div>
                              <div class="col-lg-5 col p-0 p-0 mb-4 tx-left">
                                <label class="p-0 pt-1 text-white tx-12">
                                  {{ dictionary['Activo'][session.user.language] }}
                                </label>
                                <input v-model="editDeviceData.dclId" disabled id="inputEditDeviceDclId"
                                  v-on:change="dataHasChanged=true"
                                  type="text" class="form-control form-control-line text-dark">
                              </div>
                            </div>
                          </div>

                          <div class="row justify-content-center m-0 p-0 bg-lat1 rounded-5">
                            <form class="col-12 m-0 p-2 pt-0">
                              <div class="justify-content-center text-white text-center m-0 p-0">
                                <label class="col-12 p-2 ps-4 mt-0 tx-center tx-11">
                                  {{ dictionary['Imágen del dispositivo'][session.user.language].toUpperCase() }}
                                </label>
                                <hr class="text-white m-0 ms-3 me-3">
                                <label class="col-12 p-3 pt-0 pb-2 mt-1 tx-white tx-light tx-11">
                                  {{ dictionary["Tamaño recomendado"][session.user.language] + ': 1000x1000px' }}
                                </label>

                                <img v-if="deviceImageForm?.file === ''" id="deviceImage" class="w-100 img-fluid" style="width: auto; padding: 0 1rem 1rem 1rem;"
                                  :src="displayImage(this.editDeviceData.imgSrc)">

                                <div v-if="deviceImageForm?.file != ''" class="myDeviceImagePreview w-100 ps-3 pe-3 pt-0 pb-2">
                                  <div class="d-flex flex-column">
                                    <button type="button" @click="onRemoveEditDeviceImage()" title="Remove file"
                                      style="line-height: 0; width: 25px; height: 25px"
                                      class="p-1 m-0 bg-clomos-white rounded ms-auto">
                                      <ion-icon name="close" class="tx-18 tx-black align-bottom"></ion-icon>
                                    </button>
                                    <img style="max-width: 200px; width: auto; padding: 1rem; margin: auto;"
                                      :src="displayEditDeviceImageThumbnail(deviceImageForm?.file)" />
                                  </div>
                                </div>

                                <div id="deviceImageUploadFormContainer" class="d-flex row p-3 pt-0">
                                  <input type="file" id="deviceImageUploadSrc"
                                    class="col-12 mb-3 file-button btn btn-secondary rounded tx-12"
                                    style="height: 2.3rem; min-width: 180px;" @change="onChangeEditDeviceImage"
                                    accept=".png, .jpg">

                                  <button :disabled="deviceImageForm?.file === ''" type="button"
                                    @click="setEditDeviceImage" id="deviceImageUploadSubmit"
                                    :style="(deviceImageForm?.file === '') ?'opacity: 0.6; pointer-events: none;' :''"
                                    class="col-8 ms-0 me-auto button-ok rounded-3 c-pointer" style="background-color: #03103e;">
                                    <span class="button-text text-white">
                                      <ion-icon name="image-outline" class="text-white pt-0 me-2 tx-14 hydrated"></ion-icon>
                                      <span class="text-white mt-0 tx-12">{{ dictionary['Guardar archivo'][session.user.language]}}</span>
                                    </span>
                                  </button>

                                  <button :disabled="editDeviceData.imgSrc === ''" type="button"
                                  class="col-3 ms-auto me-0 button-ok border-white rounded shadow entity-viewer-toolbar-btn c-pointer"
                                  style="background-color: #03103e;"
                                  :style="(editDeviceData.imgSrc === '') ?'opacity: 0.6; pointer-events: none;' :''"
                                  @click="onToggleDeleteDclImageModal">
                                    <span class="button-text text-white">
                                      <ion-icon name="trash-outline" class="pt-0 me-0 tx-18 hydrated" :title="dictionary['Eliminar'][session.user.language]"></ion-icon>
                                    </span>
                                  </button>
                                </div>

                              </div>
                            </form>
                          </div>
                          
                          <div v-if="editDeviceData.dclTypeId.toUpperCase().includes('BLOCK') && isFabricante" class="row justify-content-center m-0 mt-3 p-0 bg-lat1 rounded-5">
                            <div class="row bg-lat1 text-white m-0 p-0 rounded-5 border justify-content-between">
                                <!-- GENERALES -->
                              <label class="col-3 p-0 pb-2 pt-2 ps-3 mt-1 text-white tx-bold tx-16">
                                {{ dictionary['Calibrado'][session.user.language] }}
                              </label>
                              <!-- GENERALES -->
                                <label class="col-4 p-0 pb-2 pt-2 ps-3 mt-1 text-white tx-bold tx-16">
                                  {{ dictionary['Referencia'][session.user.language] + " Nº" + (deviceCalibradoForm.refs.length+1) }}:
                                </label>
                                <input v-model="deviceCalibradoForm.newRef" type="number" 
                                  class="col-4 form-control form-control-line m-auto ms-0 me-0 p-1 bg-white text-black"
                                  :id="(editDeviceData.variables.analog['Umbral superior'].isConfiguration === 'false') ? ('editDevice' + 'Umbral superior') : ('inputEditDevice' + 'Umbral superior')"
                                  style="font-size: 1rem !important; color:black; min-width: 100px; max-width: 100px; height: 2rem;">
                                <div style="width: 2rem; height: 2rem; border-radius: 1rem; border: solid 1px white;" class="c-pointer tx-18 bg-primary m-2 ms-auto p-0" @click="addRef">
                                  +
                                </div>
                                <div style="width: 2rem; height: 2rem; border-radius: 1rem; border: solid 1px white;" class="c-pointer tx-18 bg-primary m-2 ms-0 p-0" @click="removeRef"
                                :disabled="deviceCalibradoForm.refs[0]?.[0]===undefined"
                                :class="(deviceCalibradoForm.refs[0]?.[0]===undefined)?'opacity-50':''">
                                  -
                                </div>
                              <div class="row col-12 m-0 p-0" v-for="ref, i in deviceCalibradoForm.refs" :key="i" :class="(i>=1)?'mt-2':''">
                                <span class="col-4 m-auto p-0 tx-bold text-white"> 
                                  {{ "Nº" + (i+1) }}
                                </span>
                                <span class="col-4 m-auto p-0"> 
                                  {{ deviceCalibradoForm.refs[i][0] }}mm
                                </span>
                                <span class="col-4 m-auto p-0"> 
                                  {{ deviceCalibradoForm.refs[i][1] }}mm
                                </span>
                              </div>
                              <button type="button" @click="onCalibrateBlock" id="btnSubmitDeviceData"
                                :disabled="deviceCalibradoForm.refs[0]?.[0]===undefined"
                                :class="(deviceCalibradoForm.refs[0]?.[0]===undefined)?'opacity-50':''"
                                class="col-md-6 col-12 button-ok bg-primary border-white m-2 ms-auto"
                                style="max-height: 34px;">
                                <span class="button-text text-white">
                                  <ion-icon name="build-outline"
                                    class="text-white p-0 m-auto tx-24 hydrated"></ion-icon>
                                  <span class="text-white m-auto">
                                    {{ dictionary['Calibrar'][session.user.language] }}
                                  </span>
                                </span>
                              </button>
                            </div>
                          </div>
                        </div>

                        <div class="col-md-6 col-12 m-0 mb-auto p-2 pt-0">
                          <div class="row bg-lat1 text-white m-0 p-0 rounded-5 border justify-content-between">
                            <!-- VARIABLES -->
                            <label class="col-md-4 col-12 p-0 pb-2 pt-2 ps-3 mt-1 text-white tx-bold tx-16">
                              {{ dictionary['Variables'][session.user.language] }}
                            </label>
                          </div>
                          <div class="row col-12 p-0 m-0 pt-3 rounded-bottom-5 text-dark">
                            <!-- ANALOGICAS-->
                            <div v-if="Object.keys(editDeviceData.variables.analog).length > 0"
                              class='row col-12 m-0 p-0 pb-3'>
                              <span v-if=!display.analog class="col-1 bg-lat1 c-pointer rounded text-white m-2 mt-0 border-1 p-2"
                                @click="display.analog = !display.analog">+</span>
                              <span v-if=display.analog class="col-1 bg-lat1 c-pointer rounded text-white m-2 mt-0 border-1 p-2"
                                @click="display.analog = !display.analog">-</span>
                              <div class="col-10 m-0 p-0 ps-1">
                                <h6
                                  class="question col-12  border p-2 pb-2 ps-3 pe-3 m-0 text-white bg-lat1">
                                  {{ dictionary['Configuración'][session.user.language] }}
                                </h6>
                              </div>
                              <div class="col-12 p-0 list" v-if=display.analog>
                                <div class="row p-0 m-0 justify-content-start">
                                  <div class="col-12">
                                    <div class="col-12 m-0 p-0">
                                      <div class="col-12 p-0 list">
                                        
                                        <label class="tx-16 tx-white m-0 mb-3" style="width: 100%; border-bottom: solid 1px white !important;"
                                        v-if="editDeviceData.variables.analog['Presión de cierre'] || editDeviceData.variables.analog['Umbral superior']">
                                          {{ dictionary['Presión'][session.user.language] }}
                                        </label>

                                        <div class="container p-0 m-0" style="max-width:540 !important;">

                                          <div class="gradient-line-container"
                                            v-if="editDeviceData.variables.analog['Presión de cierre']">
                                            <div class="smooth-gradient-line-2"></div>
                                          </div>

                                          <div class="gradient-line-container"
                                            v-else-if="editDeviceData.variables.analog['Umbral superior']">
                                            <div class="smooth-gradient-line-1"></div>
                                          </div>

                                          <div class="controls">
                                            <!-- Variables en orden específico -->
                                            <div v-if="editDeviceData.variables.analog['Fondo de escala']"
                                              class="control-row red-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Fondo de escala'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Fondo de escala'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Fondo de escala'].isConfiguration === 'false') ? ('editDevice' + 'Fondo de escala') : ('inputEditDevice' + 'Fondo de escala')"
                                                :data-id="editDeviceData.variables.analog['Fondo de escala'].variableId"
                                                :data-type="editDeviceData.variables.analog['Fondo de escala'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Fondo de escala'].unit">
                                                {{ editDeviceData.variables.analog['Fondo de escala'].unit }}
                                              </span>
                                            </div>

                                            <div v-if="editDeviceData.variables.analog['Umbral máximo']"
                                              class="control-row red-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Umbral máximo'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Umbral máximo'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Umbral máximo'].isConfiguration === 'false') ? ('editDevice' + 'Umbral máximo') : ('inputEditDevice' + 'Umbral máximo')"
                                                :data-id="editDeviceData.variables.analog['Umbral máximo'].variableId"
                                                :data-type="editDeviceData.variables.analog['Umbral máximo'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Umbral máximo'].unit">
                                                {{ editDeviceData.variables.analog['Umbral máximo'].unit }}
                                              </span>
                                            </div>

                                            <div v-if="editDeviceData.variables.analog['Umbral superior']"
                                              class="control-row yellow-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Umbral superior'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Umbral superior'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Umbral superior'].isConfiguration === 'false') ? ('editDevice' + 'Umbral superior') : ('inputEditDevice' + 'Umbral superior')"
                                                :data-id="editDeviceData.variables.analog['Umbral superior'].variableId"
                                                :data-type="editDeviceData.variables.analog['Umbral superior'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Umbral superior'].unit">
                                                {{ editDeviceData.variables.analog['Umbral superior'].unit }}
                                              </span>
                                            </div>

                                            <div v-if="editDeviceData.variables.analog['Umbral inferior']"
                                              class="control-row yellow-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Umbral inferior'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Umbral inferior'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Umbral inferior'].isConfiguration === 'false') ? ('editDevice' + 'Umbral inferior') : ('inputEditDevice' + 'Umbral inferior')"
                                                :data-id="editDeviceData.variables.analog['Umbral inferior'].variableId"
                                                :data-type="editDeviceData.variables.analog['Umbral inferior'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Umbral inferior'].unit">
                                                {{ editDeviceData.variables.analog['Umbral inferior'].unit }}
                                              </span>
                                            </div>

                                            <div v-if="editDeviceData.variables.analog['Umbral mínimo']"
                                              class="control-row red-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Umbral mínimo'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Umbral mínimo'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Umbral mínimo'].isConfiguration === 'false') ? ('editDevice' + 'Umbral mínimo') : ('inputEditDevice' + 'Umbral mínimo')"
                                                :data-id="editDeviceData.variables.analog['Umbral mínimo'].variableId"
                                                :data-type="editDeviceData.variables.analog['Umbral mínimo'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Umbral mínimo'].unit">
                                                {{ editDeviceData.variables.analog['Umbral mínimo'].unit }}
                                              </span>
                                            </div>

                                            <div v-if="editDeviceData.variables.analog['Presión de cierre']"
                                              class="control-row green-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Presión de cierre'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Presión de cierre'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Presión de cierre'].isConfiguration === 'false') ? ('editDevice' + 'Presión de cierre') : ('inputEditDevice' + 'Presión de cierre')"
                                                :data-id="editDeviceData.variables.analog['Presión de cierre'].variableId"
                                                :data-type="editDeviceData.variables.analog['Presión de cierre'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Presión de cierre'].unit">
                                                {{ editDeviceData.variables.analog['Presión de cierre'].unit }}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        
                                        <label class="tx-16 tx-white m-0 mt-2 mb-3" style="width: 100%; border-bottom: solid 1px white !important;"
                                        v-if="editDeviceData.variables.analog['Umbral superior strength']">
                                          {{ dictionary['Fuerza'][session.user.language] }}
                                        </label>

                                        <div class="container p-0 m-0" style="max-width:540 !important;">

                                          <div class="gradient-line-container"
                                            v-if="editDeviceData.variables.analog['Umbral superior strength']">
                                            <div class="smooth-gradient-line-1"></div>
                                          </div>

                                          <div class="controls">
                                            <!-- Variables en orden específico -->
                                            <div v-if="editDeviceData.variables.analog['Fondo de escala strength']"
                                              class="control-row red-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Fondo de escala'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Fondo de escala strength'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Fondo de escala strength'].isConfiguration === 'false') ? ('editDevice' + 'Fondo de escala strength') : ('inputEditDevice' + 'Fondo de escala strength')"
                                                :data-id="editDeviceData.variables.analog['Fondo de escala strength'].variableId"
                                                :data-type="editDeviceData.variables.analog['Fondo de escala strength'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Fondo de escala strength'].unit">
                                                {{ editDeviceData.variables.analog['Fondo de escala strength'].unit }}
                                              </span>
                                            </div>

                                            <div v-if="editDeviceData.variables.analog['Umbral máximo strength']"
                                              class="control-row red-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Umbral máximo'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Umbral máximo strength'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Umbral máximo strength'].isConfiguration === 'false') ? ('editDevice' + 'Umbral máximo strength') : ('inputEditDevice' + 'Umbral máximo strength')"
                                                :data-id="editDeviceData.variables.analog['Umbral máximo strength'].variableId"
                                                :data-type="editDeviceData.variables.analog['Umbral máximo strength'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Umbral máximo strength'].unit">
                                                {{ editDeviceData.variables.analog['Umbral máximo strength'].unit }}
                                              </span>
                                            </div>

                                            <div v-if="editDeviceData.variables.analog['Umbral superior strength']"
                                              class="control-row yellow-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Umbral superior'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Umbral superior strength'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Umbral superior strength'].isConfiguration === 'false') ? ('editDevice' + 'Umbral superior strength') : ('inputEditDevice' + 'Umbral superior strength')"
                                                :data-id="editDeviceData.variables.analog['Umbral superior strength'].variableId"
                                                :data-type="editDeviceData.variables.analog['Umbral superior strength'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Umbral superior strength'].unit">
                                                {{ editDeviceData.variables.analog['Umbral superior strength'].unit }}
                                              </span>
                                            </div>

                                            <div v-if="editDeviceData.variables.analog['Umbral inferior strength']"
                                              class="control-row yellow-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Umbral inferior'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Umbral inferior strength'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Umbral inferior strength'].isConfiguration === 'false') ? ('editDevice' + 'Umbral inferior strength') : ('inputEditDevice' + 'Umbral inferior strength')"
                                                :data-id="editDeviceData.variables.analog['Umbral inferior strength'].variableId"
                                                :data-type="editDeviceData.variables.analog['Umbral inferior strength'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Umbral inferior strength'].unit">
                                                {{ editDeviceData.variables.analog['Umbral inferior strength'].unit }}
                                              </span>
                                            </div>

                                            <div v-if="editDeviceData.variables.analog['Umbral mínimo strength']"
                                              class="control-row red-row" style="max-height: 34px;">
                                              <label style="width: 180px;color:white;font-size: 14px;padding: 6px;">{{ dictionary['Umbral mínimo'][session.user.language] }}:</label>
                                              <input v-model="editDeviceData.variables.analog['Umbral mínimo strength'].value" type="number"
                                                v-on:change="variablesHasChanged=true"
                                                class="inputEditDevice form-control form-control-line m-0 p-1 bg-white text-black"
                                                :id="(editDeviceData.variables.analog['Umbral mínimo strength'].isConfiguration === 'false') ? ('editDevice' + 'Umbral mínimo strength') : ('inputEditDevice' + 'Umbral mínimo strength')"
                                                :data-id="editDeviceData.variables.analog['Umbral mínimo strength'].variableId"
                                                :data-type="editDeviceData.variables.analog['Umbral mínimo strength'].type"
                                                style="font-size: 1rem !important; color:black; max-width: 150px;">
                                              <span class="text-nowrap ms-auto text-white"
                                                v-if="editDeviceData.variables.analog['Umbral mínimo strength'].unit">
                                                {{ editDeviceData.variables.analog['Umbral mínimo strength'].unit }}
                                              </span>
                                            </div>

                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>

                                  <div class="row p-0 m-0">
                                    <div v-for="group in [0,1,2,3,4,5,6,7,8,9,10]" :key="group" class="d-flex w-100 flex-wrap justify-content-start m-0 p-0" 
                                    :style="(analogByDistributionGroup.filter(v=> v.distributionGroup === group).length >= 1) ?'border-bottom: solid 1px white; padding-bottom: 0.5rem !important;' :'display: none;'">
                                      <div v-for="(variable) in analogByDistributionGroup.filter(v=> v.distributionGroup === group)" :key="variable.variableId">
                                        <div class="m-0 ps-2 pe-2">
                                          <label class="col-12 tx-11 p-0 pt-2 pb-2 text-white">
                                            {{ variable.label }}
                                          </label>
                                          <input v-model="editDeviceData.variables.analog[variable.label].value" type="number"
                                            v-on:change="variablesHasChanged=true"
                                            class="inputEditDevice form-control form-control-line m-0 p-2 bg-white text-black"
                                            :id="(variable.isConfiguration === 'false') ? ('editDevice' + variable.label) : ('inputEditDevice' + variable.label)"
                                            :data-id="variable.variableId"
                                            :data-type="variable.type"
                                            style="font-size: 1rem !important; color:white; min-width: 0 !important">
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  
                                </div>
                              </div>
                            </div>
                           <!-- ANALOGICAS-->

                            <!-- DIGITALES-->
                            <div v-if="Object.keys(editDeviceData.variables.digital).length > 0"
                              class='row col-12 m-0 p-0 pb-3'>
                              <span v-if=!display.digital class="col-1 bg-lat1 c-pointer rounded text-white m-2 mt-0 border-1 p-2"
                                @click="display.digital = !display.digital">+</span>
                              <span v-if=display.digital class="col-1 bg-lat1 c-pointer rounded text-white m-2 mt-0 border-1 p-2"
                                @click="display.digital = !display.digital">-</span>
                              <div class="col-10 m-0 p-0 ps-1">
                                <h6
                                  class="question col-12  border p-2 pb-2 ps-3 pe-3 m-0 text-white bg-lat1">
                                  {{ dictionary['Tipo digitales'][session.user.language] }}
                                </h6>
                              </div>
                              <div class="col-12 p-0 list " v-if=display.digital>
                                <div class="row p-0 m-0">
                                  <div v-for="group in [0,1,2,3,4,5,6,7,8,9,10]" :key="group" class="d-flex w-100 flex-wrap justify-content-start m-0 p-0" 
                                  :style="(digitalByDistributionGroup.filter(v=> v.distributionGroup === group).length >= 1) ?'border-bottom: solid 1px white; padding-bottom: 0.5rem !important;' :'display: none;'">
                                    <div v-for="(variable) in digitalByDistributionGroup.filter(v=> v.distributionGroup === group)" :key="variable.variableId">
                                      <div class="m-0 ps-2 pe-2">
                                        <label class="col-12 tx-11 p-0 pt-2 pb-2 text-white">
                                          {{ variable.label }}
                                        </label>
                                        <div :class="editDeviceData.variables.digital[variable.label].value"
                                          :id="(variable.isConfiguration === 'false') ? ('editDevice' + variable.label) : 'inputEditDevice' + variable.label"
                                          :data-id="editDeviceData.variables.digital[variable.label].variableId"
                                          :data-type="editDeviceData.variables.digital[variable.label].type"
                                          :data-value="editDeviceData.variables.digital[variable.label].value"
                                          class="inputEditDevice form-control form-control-line border-0 m-0 p-2 bg-white text-black tx-10"
                                          @click="handleClick(variable)">
                                          {{
                                            dictionary[editDeviceData.variables.digital[variable.label].value][session.user.language]
                                          }}
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            <!-- FIN VARIABLES -->

                            <!-- VARIABLES DE TEXTO -->
                            <div v-if="Object.keys(editDeviceData.variables.dynamic).length > 0"
                              class='row col-12 m-0 p-0 pb-3'>
                              <span v-if=!display.dynamic class="col-1 bg-lat1 c-pointer rounded text-white m-2 mt-0 border-1 p-2"
                                @click="display.dynamic = !display.dynamic">+</span>
                              <span v-if=display.dynamic class="col-1 bg-lat1 c-pointer rounded text-white m-2 mt-0 border-1 p-2"
                                @click="display.dynamic = !display.dynamic">-</span>
                              <div class="col-10 m-0 p-0 ps-1">
                                <h6
                                  class="question col-12  border p-2 pb-2 ps-3 pe-3 m-0 text-white bg-lat1">
                                  {{ dictionary['Tipo texto'][session.user.language] }}
                                </h6>
                              </div>
                              <div class="col-12 p-0 list" v-if=display.dynamic>
                                <div class="row col-12 p-0 m-0">
                                  <div v-for="group in [0,1,2,3,4,5,6,7,8,9,10]" :key="group" class="d-flex w-100 flex-wrap justify-content-start m-0 p-0" 
                                  :style="(dynamicByDistributionGroup.filter(v=> v.distributionGroup === group).length >= 1) ?'border-bottom: solid 1px white; padding-bottom: 0.5rem !important;' :'display: none;'">
                                    <div v-for="(variable) in dynamicByDistributionGroup.filter(v=> v.distributionGroup === group)" :key="variable.variableId">
                                      <div class="m-0 ps-2 pe-2">
                                        <label class="col-12 tx-11 p-0 pt-2 pb-2 text-white">
                                          {{ variable.label }}
                                        </label>
                                        <input v-model="editDeviceData.variables.dynamic[variable.label].value"
                                          v-on:change="variablesHasChanged=true"
                                          :id="(variable.isConfiguration === 'false') ? ('editDevice' + variable.label) : 'inputEditDevice' + variable.label"
                                          :data-id="editDeviceData.variables.dynamic[variable.label].variableId"
                                          :data-type="editDeviceData.variables.dynamic[variable.label].type"
                                          class="inputEditDevice form-control form-control-line m-0 p-2 bg-white text-black"
                                          style="font-size: 1rem !important; color:black;">
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="col-md-6 col-12 m-0 mb-4 p-2 pt-0"
                            hidden>
                            <!-- CONTENT Blueprint -->
                            <label class="col p-0 pb-2 pt-0 ps-3 mt-1 text-white tx-bold tx-16">
                              {{ dictionary['Calibrar'][session.user.language] }}
                            </label>
                            <button type="button" @click="setDeviceVariables" id="btnSubmitDeviceVariables"
                              class="col-md-6 col-12 button-ok bg-lat1 border-white rounded-3 m-2"
                              style="max-height: 34px;">
                              <span class="button-text text-white">
                                <ion-icon name="create-outline"
                                  class="text-white p-0 m-auto tx-24 hydrated"></ion-icon>
                                <span class="text-white m-auto">
                                  {{ dictionary['Guardar variables'][session.user.language] }}
                                </span>
                              </span>
                            </button>
                          </div>
                        </div>

                      </div>
                    </form>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
</template>

<script>
import $ from 'jquery';
import Leaflet from 'leaflet';
// Clomos
import api from '@/services/api';

export default {
  name: "EditDeviceModal",
  props: {
    session: {
      type: Object,
      required: true,
    },
    dictionary: {
      type: Object,
      required: true,
    },
    countries: {
      type: Object,
      required: true,
    },
    timeZones: {
      type: Object,
      required: true,
    },
    typesByCompany: {
      type: Object,
      required: true,
    },
    targetDeviceId: {
      type: String,
      required: true,
    },
    isOperario: {
      type: Boolean,
      required: true
    },
    isMantenimiento: {
      type: Boolean,
      required: true
    },
    isFabricante: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      originalDeviceVariables: {},
      editDeviceData: {
        id: "",
        nifCif: "",
        dataConsumed: "",
        label: "",
        dclId: "",
        dclTypeId: "",
        dclClass: "",
        type: "",
        distributionGroup: "",
        parent: "",
        isBase: "",
        isPublic: 0,
        token: "",
        imgSrc: "",
        emplacement: "",
        version: "",
        geoJSON: {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [0, 0]
          }
        },
        variables: {
          analog: {},
          digital: {},
          dynamic: {},
        }
      },
      deviceConfigurationForm: {
        id: "",
        variableId: "",
        value: ""
      },
      deviceImageForm: {
        id: this.targetDeviceId,
        variableId: "",
        nifCif: "",
        src: "",
        file: "",
        oldFileName: ""
      },
      deviceCalibradoForm: {
        newRef: 0.0,
        refs: []
      },
      deviceMap: undefined,
      deviceMarker: undefined,
      //deviceId: this.$route.params.targetEntity,
      display: {
        analog: true,
        digital: true,
        dynamic: true,
      },
      dataHasChanged: false,
      variablesHasChanged: false,
      showConfiguration: ""
    }
  },
  emits: ['toggleEditDeviceModal', "handleHasRol"],
  computed: {
    analogByDistributionGroup() {
      const variablesArray = Object.values(this.editDeviceData.variables.analog)
        .map(v => ({
          ...v,
          distributionGroup: parseInt(v.distributionGroup, 10) || 0
        }))
        .filter(v => v.isConfiguration === 'true')
        .filter(v => v.label  != 'Fondo de escala')
        .filter(v => v.label  != 'Umbral máximo')
        .filter(v => v.label  != 'Umbral superior')
        .filter(v => v.label  != 'Umbral inferior')
        .filter(v => v.label  != 'Umbral mínimo')
        .filter(v => v.label  != 'Presión de cierre')
        .filter(v => v.label  != 'Fondo de escala strength')
        .filter(v => v.label  != 'Umbral máximo strength')
        .filter(v => v.label  != 'Umbral superior strength')
        .filter(v => v.label  != 'Umbral inferior strength')
        .filter(v => v.label  != 'Umbral mínimo strength')
        .filter(v => v.isConfiguration === 'true')
      variablesArray.sort((a, b) => a.distributionGroup - b.distributionGroup);
      return variablesArray;
    },
    digitalByDistributionGroup() {
      const variablesArray = Object.values(this.editDeviceData.variables.digital)
        .map(v => ({
          ...v,
          distributionGroup: parseInt(v.distributionGroup, 10) || 0
        }))
        .filter(v => v.isConfiguration === 'true')
      variablesArray.sort((a, b) => a.distributionGroup - b.distributionGroup);
      return variablesArray;
    },
    dynamicByDistributionGroup() {
      const variablesArray = Object.values(this.editDeviceData.variables.dynamic)
        .map(v => ({
          ...v,
          distributionGroup: parseInt(v.distributionGroup, 10) || 0
        }))
        .filter(v => v.isConfiguration === 'true')
      variablesArray.sort((a, b) => a.distributionGroup - b.distributionGroup);
      return variablesArray;
    }
  },

  methods: {
    // CALIBRADO
    async addRef() {
      let response = await api.getDeviceData(this.targetDeviceId);
      let deviceData = api.parseDeviceFromResponse(response);
      let position = deviceData.variables.analog['Position']?.value || 0.0;
      this.deviceCalibradoForm.refs.push([this.deviceCalibradoForm.newRef, position])
      this.deviceCalibradoForm.newRef = 0.0;
    },
    removeRef() {
      this.deviceCalibradoForm.refs.pop()
    },
    async onCalibrateBlock() {
      let variablesData = {
        deviceId : this.targetDeviceId
      }
      variablesData["Position Raw"] = {
        id: this.editDeviceData.variables.analog["Position Raw"].variableId,
        type: this.editDeviceData.variables.analog["Position Raw"].type
      }
      let coeficiente = "0";
      let calibrateData = {
        "OnRead": {
          "Accion": "PolGrado2",
          "Salida": "Position",
          "Coeficiente": coeficiente
        }
      }
      for (let n in this.deviceCalibradoForm.refs) {
        calibrateData["OnRead"]["Coeficiente"+(n+1)] = this.deviceCalibradoForm.refs[n][1]
      }
      variablesData.calibrateData = calibrateData;
      let response = await api.calibrateBlock(calibrateData);
      if (response["status-code"] === "200" || response["status-code"] === "304") {
        window.alert("El dispositivo ha sido calibrado correctamente." );
      }
      else {
        window.alert("Error al calibrar.");
      }
    },
    handleClick(variable) {
      if (variable.isConfiguration === 'false') {
        return;
      }
      this.variablesHasChanged=true
      const currentValue = this.editDeviceData.variables.digital[variable.label].value;
      this.editDeviceData.variables.digital[variable.label].value = currentValue === 'true' ? 'false' : 'true';
    },
    // DISPLAY
    displayImage(src) {
      if (src != undefined && src != '') {
        try {
          return this.$clientConfig.api + '/ficheros/ficheros.php?fichero=' + src + '&identificadorusuario=' + this.session.user.id + '&Token=' + localStorage.getItem("ClomosAuthToken");
        }
        catch (e) {
          console.warn(e);
        }
      }
      return require('@/assets/img/placeholder_image.jpg');
    },
    onChangeEditDeviceImage(event) {
      if (event.target.files[0] != undefined && event.target.files[0].size > 2097152) {
        this.onRemoveEditDeviceImage();
        alert("El tamaño del fichero debe ser inferior a 2Mb.");
        return;
      }
      if ((event.target.files[0]?.name || "") === "") {
        this.onRemoveEditDeviceImage();
        alert("Ningún fichero seleccionado.");
        return;
      }
      this.deviceImageForm.nifCif = this.editDeviceData.nifCif;
      this.deviceImageForm.file = event.target.files[0];
      this.deviceImageForm.src = event.target.files[0].name;
      this.deviceImageForm.name = event.target.files[0].name;
      this.deviceImageForm.oldFileName = ""+this.editDeviceData.imgSrc;
    },
   onRemoveEditDeviceImage() {
      $("#deviceImageUploadSrc").get()[0].value = "";
      this.deviceImageForm.nifCif = "";
      this.deviceImageForm.file = "";
      this.deviceImageForm.src = this.editDeviceData.imgSrc;
      this.deviceImageForm.name = this.editDeviceData.imgSrc;
      this.deviceImageForm.oldFileName = "";
    },
    displayEditDeviceImageThumbnail(file) {
      if (file === '' || file === undefined) return "";
      let fileSrc = URL.createObjectURL(file);
      setTimeout(() => {
        URL.revokeObjectURL(fileSrc);
      }, 1000);
      return fileSrc;
    },
    async setEditDeviceImage() {
      let response = await api.setDeviceImage(this.deviceImageForm);
      console.log(response);
      this.onRemoveEditDeviceImage();
      this.getEditDeviceData();
    },
    displayDeviceMap() {
      if (this.deviceMap != undefined) {
        this.deviceMap.invalidateSize();
        this.deviceMap.remove();
      }

      const coordinates = this.editDeviceData.geoJSON?.geometry?.coordinates;

      if (
        !coordinates ||
        coordinates.length < 2 ||
        coordinates[0] === 0 ||
        coordinates[1] === 0
      ) {
        return;
      }

      var deviceMap = Leaflet.map("deviceMapContent", {
        scrollWheelZoom: true,
        zoomControl: true
      });

      Leaflet.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png?lang=' + this.session.user.language, { maxZoom: 30 }).addTo(deviceMap);

      if (this.showConfiguration === "true") {
        deviceMap.on('click', this.onSetNewCoordinates);
      }

      this.deviceMap = deviceMap;

      let deviceMapListForGroup = [];
      if ($(".leaflet-control-attribution").get()[0] != undefined) $(".leaflet-control-attribution").get()[0].remove();
      let options = { icon: this.mapIcon() };

      var deviceMarker = Leaflet.marker([coordinates[0], coordinates[1]], options);
      deviceMarker.addTo(deviceMap);
      deviceMapListForGroup.push(deviceMarker);

      var deviceMapGroup = Leaflet.featureGroup(deviceMapListForGroup);
      this.deviceMap.fitBounds(deviceMapGroup.getBounds());

      this.$nextTick(() => {
        const currentZoom = this.deviceMap.getZoom();
        this.deviceMap.setZoom(currentZoom - 12);
      });

      this.deviceMarker = deviceMarker;
    },
    mapIcon() {
      const iconHTML = `
        <ion-icon name=location
          class="btnTargetDevice border-white tx-36 c-pointer " 
          style="vertical-align: middle; color: blue;">
        </ion-icon>`;

      const customIcon = Leaflet.divIcon({
        html:
          iconHTML,
        className: "",
        iconSize: [52, 52],
      });
      return customIcon;
    },
    /*   displayBlueprint() {
        setTimeout(() => {
          this.onPositionChanged();
        }, 300);
        let src = "";
        if (this.editDeviceData.parent != ""
          && this.editDeviceData.geoJSON != undefined
          && this.editDeviceData.geoJSON.properties != undefined
          && this.editDeviceData.geoJSON.properties.srcId != undefined)
          src = this.editDeviceData.geoJSON.properties.srcId;
        if (src != undefined && src != '') {
          try {
            return this.$clientConfig.api + '/ficheros/ficheros.php?fichero=' + src + '&identificadorusuario=' + this.session.user.id + '&Token=' + localStorage.getItem("ClomosAuthToken");
          }
          catch (e) {
            console.warn(e);
          }
        }
        return require('/src/assets/img/placeholder_image.jpg');
      }, */
    onPositionChanged() {
      this.deviceMap.removeLayer(this.deviceMarker);
      let options = { icon: this.mapIcon() };
      this.deviceMarker = Leaflet.marker([this.editDeviceData.geoJSON.geometry.coordinates[0], this.editDeviceData.geoJSON.geometry.coordinates[1]], options).addTo(this.deviceMap);
    },
    // SET
    async saveDevice() {
      if (this.dataHasChanged === true) await this.setEditDeviceData();
      if (this.variablesHasChanged === true) await this.setDeviceVariables();
    },
    async setEditDeviceData() {
      let response = await api.setDeviceData(this.editDeviceData);
      if (response["status-code"] === "200") {
        window.alert("El dispositivo ha sido modificado satisfactoriamente.");
      }
      else {
        window.alert("Error al modificar el dispositivo.");
      }
      this.getEditDeviceData();
    },
    async setDeviceVariables() {
      let variablesData = {
        deviceId: this.editDeviceData.id
      };
      let changedVariables = this.getChangedVariables();
      $(".inputEditDevice").get().forEach(input => {
        let variableLabel = input.id.replace("inputEditDevice", "");
        let ic = false;
        let hc = false;
        if (this.editDeviceData.variables.analog[variableLabel] != undefined
          && this.editDeviceData.variables.analog[variableLabel].isConfiguration === "true")
          ic = true;
        else if (this.editDeviceData.variables.digital[variableLabel] != undefined
          && this.editDeviceData.variables.digital[variableLabel].isConfiguration === "true")
          ic = true;
        else if (this.editDeviceData.variables.dynamic[variableLabel] != undefined
          && this.editDeviceData.variables.dynamic[variableLabel].isConfiguration === "true")
          ic = true;
        if (changedVariables[variableLabel] != undefined) 
          hc = true;
        if (ic && hc) {
          variablesData[variableLabel] = {
            value: (input.getAttribute("data-type") === "0")
              ? (input.getAttribute("data-value") === "true")
                ? 1
                : 0
              : input.value,
            id: input.getAttribute("data-id"),
            type: input.getAttribute("data-type")
          }
        }
      });
      let response = await api.setDeviceVariables(variablesData);
      if (response["status-code"] === "200") {
        window.alert("Las variables han sido modificado satisfactoriamente.");
      }
      else {
        window.alert("Error al modificar el dispositivo.");
      }
      this.getEditDeviceData();
    },
    onSetNewCoordinates(event) {
      if (this.editDeviceData.parent != "") {
        let target = event.target;
        let totalOffsetLeft = target.offsetLeft;
        let totalOffsetTop = target.offsetTop;
        let totalScrollLeft = target.scrollLeft;
        let totalScrollTop = target.scrollTop;
        while (target.offsetParent != undefined) {
          target = target.offsetParent;
          totalOffsetLeft += target.offsetLeft;
          totalOffsetTop += target.offsetTop;
          totalScrollLeft += target.scrollLeft;
          totalScrollTop += target.scrollTop;
        }
        let ratioX = event.target.naturalWidth / event.target.offsetWidth;
        let ratioY = event.target.naturalHeight / event.target.offsetHeight;

        let domX = event.x + totalScrollLeft - totalOffsetLeft;
        let domY = event.y + totalScrollTop - totalOffsetTop;

        this.editDeviceData.geoJSON.geometry.coordinates[0] = Math.floor(domX * ratioX);
        this.editDeviceData.geoJSON.geometry.coordinates[1] = Math.floor(domY * ratioY);

        this.onPositionChanged();
      }
      else {
        this.editDeviceData.geoJSON = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: [Number(event.latlng.lat), Number(event.latlng.lng)]
          }
        }
        this.deviceMap.removeLayer(this.deviceMarker);
        let options = { icon: this.mapIcon() };
        this.deviceMarker = Leaflet.marker([this.editDeviceData.geoJSON.geometry.coordinates[0], this.editDeviceData.geoJSON.geometry.coordinates[1]], options).addTo(this.deviceMap);
      }
    },
    async setDeviceConfiguration() {
      let response = await api.setDeviceConfiguration(this.deviceConfigurationForm);
      if (response["status-code"] === "200") {
        window.alert("El dispositivo ha sido modificado satisfactoriamente.");
      }
      else {
        window.alert("Error al modificar el dispositivo.");
      }
      this.getEditDeviceData();
    },
    async onToggleDeleteDclImageModal() {
      if (window.confirm(this.dictionary['¿Seguro que desea eliminar el fichero?'][this.session.user.language])) {
        this.onRemoveEditDeviceImage();
        await this.setEditDeviceImage();
        this.getEditDeviceData();
      } else {
        // Cancel
      }
    },
    // GET 
    async getEditDeviceData(callback) {
      let response = await api.getDeviceData(this.targetDeviceId);
      this.editDeviceData = api.parseDeviceFromResponse(response);
      let typeCategory = this.typesByCompany?.deviceTypeList?.filter(
        type => type.id === this.editDeviceData.dclTypeId
      );
      this.editDeviceData.category = typeCategory && typeCategory.length > 0 ? typeCategory[0].category : "";
      this.deviceConfigurationForm.id = this.editDeviceData.id;

      if (this.editDeviceData.variables.dynamic['configuracion'] != undefined) {
        this.deviceConfigurationForm = {
          id: this.editDeviceData.id,
          variableId: this.editDeviceData.variables.dynamic['configuracion'].variableId,
          value: this.editDeviceData.variables.dynamic['configuracion'].value
        };
      } else {
        this.deviceConfigurationForm = {
          id: this.editDeviceData.id,
          variableId: "",
          value: ""
        };
      }

      this.getVariables();

      this.originalDeviceVariables = JSON.parse(
        JSON.stringify(this.editDeviceData.variables)
      );
      this.dataHasChanged = false;
      this.variablesHasChanged = false;
      this.deviceImageForm.id = this.editDeviceData.id;
      this.deviceImageForm.variableId = this.editDeviceData.imgSrc;
      this.deviceImageForm.name = this.editDeviceData.imgSrc;
      if (callback && typeof callback === "function") {
        callback(this.editDeviceData);
      }
    },
    getVariables() {
      const variables = {
        analog: {},
        digital: {},
        dynamic: {},
      };

      for (let key in this.editDeviceData.variables.analog) {
        const analogVariable = this.editDeviceData.variables.analog[key];
        if (analogVariable?.isConfiguration === 'true') {
          variables.analog[key] = analogVariable;
        }
      }

      for (let key in this.editDeviceData.variables.digital) {
        const digitalVariable = this.editDeviceData.variables.digital[key];
        if (digitalVariable?.isConfiguration === 'true') {
          variables.digital[key] = digitalVariable;
        }
      }

      for (let key in this.editDeviceData.variables.dynamic) {
        const dynamicVariable = this.editDeviceData.variables.dynamic[key];
        if (dynamicVariable?.isConfiguration === 'true') {
          variables.dynamic[key] = dynamicVariable;
        }
      }

      const analogCount = Object.keys(variables.analog).length;
      const digitalCount = Object.keys(variables.digital).length;
      const dynamicCount = Object.keys(variables.dynamic).length;
      const totalVariables = analogCount + digitalCount + dynamicCount;
      if (totalVariables <= 12) {
        this.display.analog = true;
        this.display.digital = true;
        this.display.dynamic = true;
      }

      this.editDeviceData.variables = { ...variables };
    },

    getChangedVariables() {
      const changed = {};

      const types = ["digital", "analog", "dynamic"];

      for (const type of types) {
        const current = this.editDeviceData.variables[type];
        const original = this.originalDeviceVariables[type];

        if (!current || !original) continue;

        for (const label in current) {
          if (
            current[label].isConfiguration === "true" &&
            current[label].value !== original[label]?.value
          ) {
            changed[label] = {
              value:
                current[label].type === "0"
                  ? current[label].value === "true" ? 1 : 0
                  : current[label].value,
              id: current[label].variableId,
              type: current[label].type
            };
          }
        }
      }

      return changed;
    } 
  },
  async created() {
    if (this.$route.params.currentDisplay == 'deviceconfig') {
      this.showConfiguration = 'true';
    } else {
      this.showConfiguration = 'false';
    }
    if (!this.isMantenimiento) {
      window.alert("No tiene permiso para visualizar esta pagina. Contacte con el administrador del sistema");
      this.$router.go(-1)
    }
    await this.getEditDeviceData();
  }
}
</script>

<style>
#editDeviceModal {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100vw;
  height: 100vh;
}

.container {
  display: flex;
  gap: 20px;
  align-items: center;
  padding: 0;
  margin: 0;
}


.controls {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.control-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-radius: 4px;
}

.red-row {
  background-color: rgba(255, 0, 0, 0.1);
  border-left: 3px solid #ff0000;
}

.green-row {
  background-color: rgba(0, 255, 0, 0.1);
  border-left: 3px solid #00ff00;
}

.yellow-row {
  background-color: rgba(255, 255, 0, 0.1);
  border-left: 3px solid #ffff00;
}

label {
  text-align: start;
  min-width: 100px;
  font-weight: bold;
}

input {
  padding: 8px;
  border: 1px solid #ddd;
  border-radius: 4px;
  min-width: 200px;
}

.gradient-line-container {
  display: flex;
  justify-content: center;
  height: 230px;
  /* Ajusta según necesites */
  padding-right: 0px;;
}

.smooth-gradient-line-1 {
  width: 10px;
  height: 100%;
  background: linear-gradient(to bottom,
      #ff0000 0%,
      #ffff00 55%,
      #00ff00 60%,
      #ffff00 65%,
      #ff0000 100%
    );
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.smooth-gradient-line-2 {
  width: 10px;
  height: 100%;
  background: linear-gradient(to bottom,
      #ff0000 0%,
      #ffff00 30%,
      #00ff00 35%,
      #ffff00 40%,
      #ff0000 80%,
      #ffff00 95%,
      #00ff00 100%
    );
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2);
}

.modal-overlay {
  background-color: rgba(0, 0, 0, 0.5) !important;
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw !important;
  height: 100vh !important;
  z-index: 99999 !important;
  display: flex;
  justify-content: center;
  align-items: center;
}

.inputEditDevice:disabled {
  color: dimGrey;
}



.show {
  display: none;
}

.hide:target+.show {
  display: inline;
}

.hide:target {
  display: none;
}

.hide:target~.list {
  display: inline;
}

/*style the (+) and (-) */
.hide,
.show {
  width: 40px !important;
  height: 30px;
  border-radius: 7px;
  font-size: 18px;
  color: #fff;
  text-shadow: 0 1px 0 #666;
  text-align: center;
  text-decoration: none;
  box-shadow: 1px 1px 2px #000;
  background: #666;
  opacity: .95;
  margin-right: 0;
  float: left;
  margin-left: 8px;
  margin-bottom: 5px;
}

.hide:hover,
.show:hover {
  color: #eee;
  text-shadow: 0 0 1px #666;
  text-decoration: none;
  box-shadow: 0 0 4px #222 inset;
  opacity: 1;
  margin-bottom: 5px;
}

.list p {
  height: auto;
  margin: 0;
}

.question {
  float: left;
  height: auto;
  line-height: 20px;
  padding-left: 20px;
  margin-bottom: 25px;
}
</style>